import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, ClipboardList, Users, LogOut, Contact, Truck } from "lucide-react";
import { Logo } from "./Bits2";
import { useAuth } from "../context/AuthContext";
import { useCart } from "../context/CartContext";

export const AppShell = () => {
  const { user, logout } = useAuth();
  const { lines } = useCart();
  const nav = useNavigate();
  const isAdmin = user.role === "admin";
  const links = [
    ...(isAdmin ? [{ to: "/", label: "Panel", icon: LayoutDashboard, id: "dashboard" }] : []),
    { to: "/urunler", label: "Ürünler", icon: Package, id: "products" },
    { to: "/siparis-olustur", label: "Sipariş Oluştur", icon: ShoppingCart, id: "new-order", badge: lines.length },
    { to: "/siparisler", label: isAdmin ? "Siparişler" : "Siparişlerim", icon: ClipboardList, id: "orders" },
    ...(user.role !== "customer" ? [{ to: "/musteriler", label: "Müşteriler", icon: Contact, id: "customers" }] : []),
    ...(isAdmin ? [{ to: "/alislar", label: "Alışlar", icon: Truck, id: "purchases" }] : []),
    ...(isAdmin ? [{ to: "/kullanicilar", label: "Kullanıcılar", icon: Users, id: "users" }] : []),
  ];
  const cls = ({ isActive }) =>
    `relative flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-200 ${isActive ? "bg-slate-950 text-white" : "text-slate-600 hover:bg-slate-200/70 hover:text-slate-950"}`;

  return (
    <div className="min-h-screen bg-[hsl(210,40%,98%)] pb-20 lg:pb-0">
      <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/80 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6">
          <div className="flex items-center gap-8">
            <Logo />
            <nav className="hidden lg:flex items-center gap-1">
              {links.map((l) => (
                <NavLink key={l.to} to={l.to} end={l.to === "/"} className={cls} data-testid={`nav-${l.id}-link`}>
                  <l.icon className="h-4 w-4" /> {l.label}
                  {l.badge > 0 && <span className="ml-1 rounded-full bg-blue-600 px-1.5 text-[10px] font-bold text-white" data-testid="nav-cart-count">{l.badge}</span>}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <div className="hidden sm:block text-right">
              <p className="text-sm font-semibold leading-tight" data-testid="current-user-name">{user.name}</p>
              <p className="font-mono text-[10px] uppercase tracking-wider text-slate-500">{isAdmin ? "Yönetici" : user.role === "customer" ? "Müşteri" : "Plasiyer"}</p>
            </div>
            <button data-testid="logout-button" onClick={async () => { await logout(); nav("/giris"); }}
              className="grid h-9 w-9 place-items-center rounded-lg border border-slate-200 text-slate-600 transition-colors hover:bg-slate-950 hover:text-white" title="Çıkış">
              <LogOut className="h-4 w-4" />
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 sm:py-10"><Outlet /></main>
      <nav className="fixed inset-x-0 bottom-0 z-30 flex justify-around border-t border-slate-200 bg-white/95 backdrop-blur-xl py-2 lg:hidden">
        {links.map((l) => (
          <NavLink key={l.to} to={l.to} end data-testid={`mobile-nav-${l.id}-link`}
            className={({ isActive }) => `relative flex flex-col items-center gap-0.5 px-2 text-[10px] font-medium ${isActive ? "text-blue-600" : "text-slate-500"}`}>
            <l.icon className="h-5 w-5" /> {l.label.split(" ")[0]}
            {l.badge > 0 && <span className="absolute -top-1 right-1 rounded-full bg-blue-600 px-1 text-[9px] font-bold text-white">{l.badge}</span>}
          </NavLink>
        ))}
      </nav>
    </div>
  );
};
